<template>
  <div>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>

    <v-dialog v-if="iptalDialog" persistent v-model="iptalDialog" max-width="350px">
      <v-card>
        <v-card-text>
          <v-container>

            <v-form ref="formiptal" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12 pb-3 sm12 md12>
                  <v-layout class="project overdue" row wrap>

                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title> <span class="subheading black--text">
                          {{ $t('Change-Transfer-Date') }}
                        </span> </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>

                <!-- <v-flex pl-4 xs3 md3 sm3>
                  <span> {{ $t('PNR-No') }} </span>
                </v-flex>
                <v-flex xs9 md9 sm9>
                  <span>:5464564 </span>
                </v-flex> -->




                <v-flex xs12 md9 sm9>
                  <tarihcomp :rules="[v => !!v || $t('Mandatory-Areas')]" :etiket="'Yeni Tarihi Seçiniz'"
                    v-bind:detaygizle="true" v-bind:defaultvalue="'ok'" v-bind:value="TransferDate"
                    v-model="TransferDate">
                  </tarihcomp>
                </v-flex>
                <v-flex xs12 md3 sm3>
                  <v-text-field label="Saat" hide-details :rules="[v => !!v || $t('Mandatory-section')]" v-model="TransferTime"
                    type="time">

                  </v-text-field>
                </v-flex>

                <v-flex xs12 md12 pt-2 sm12>
                  <v-btn color="info" outline block @click="transferDegistir()">
                    <span>Transfer Tarihini Değiştir</span>
                  </v-btn>
                </v-flex>





              </v-layout>

            </v-form>

          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click.native="islemIptal()">{{$t("cancel_button")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from '@/components/app/customcomp/tarihim'
  import loadingcomp from "@/components/app/customcomp/loadingcomp"


  export default {
    props: ["value"],
    components: {
      tarihcomp,
      loadingcomp
    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      }

    },

    methods: {
      transferDegistir() {

        if (this.$refs.formiptal.validate()) {
          var credentials = JSON.parse(window.localStorage.getItem('credentials'));
          this.loadingvmodel = true

          var rezid = this.kalemData.entId.split("-");

          var params = {
            LogInput: {
              UserID: credentials.UserID,
              CustomerID: credentials.MusteriID
            },
            BookingNumber: rezid[0],
            TransferDate: this.TransferDate,
            TransferTime: this.TransferTime + ':00',
          }


          this.$http.post(auth.PAXDRIVE_API_URL + 'api/Transfer/EditBookingDate', params, {
            headers: {
              'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME +
                ':' + auth
                .HOTELRUNNERUSERPASS)
            }
          }).then((response) => {


            if (response.body.Status == true) {


              this.loadingvmodel = false
              this.iptalDialog = false

              this.sonuc.status = true
              this.sonuc.message=response.body.Message
              this.sonuc.data.tarih = this.TransferDate
              this.sonuc.data.saat = this.TransferTime

              this.resolve(this.sonuc);


            } else {
              this.text1 = response.body.Message
              this.snackbar = true
              this.loadingvmodel = false

            }

          }, (response) => {
            this.text1 = this.$t('error-occurred-please-try-again')
            this.snackbar = true
            this.loadingvmodel = false
          })

        }


      },
      onay() {
        this.iptalDialog = false
        this.resolve(true);
      },
      islemIptal() {
        this.sonuc.status = false

        this.resolve(this.sonuc);
        this.iptalDialog = false
      },
      open(mesaj, data) {
        this.kalemData = data
        this.TransferDate = data.donem1
        this.TransferTime = helpers.getTime(data.kalemArac.seferSaat)
        this.mesaj = mesaj
        this.iptalDialog = true;
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },
    },
    data() {
      return {
        sonuc: {
          status: false,
          message:null,
          data: {
            tarih: null,
            saat: null
          }
        },
        pddata: {},
        valid: true,
        loadingvmodel: false,
        TransferDate: null,
        TransferTime: null,

        mesaj: null,
        alertshow: false,
        alertmodel: true,
        tahsilatbakiyem: 0,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        iptalDialog: false,
        tahsilatguncellebuton: false,
        k: null,
        doviztipi: [],
        reject: null,
        bankapositems: [],
        itemsbanka: [],
        statecaritahsilat: [],
        itemsevraktipi: [],
        tahsilatdialog: false,
        text1: null,
        searchcaritahsilat: '',
        taksitsayitahsilat: [],
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },


    watch: {

    },
  }




  function beforeMount() {

  }
</script>